export enum PositionAssistantTypeEnum {
  Task = 'TASK',
  Milestone = 'MILESTONE',
}
